import request from '@/utils/request';

export function getReviews(params) {
  return request({
    url: '/admin/reviews',
    method: 'get',
    params,
  });
}

export function deleteReview(id) {
  return request({
    url: `/admin/reviews/${id}`,
    method: 'delete',
  });
}
